module.exports = __webpack_public_path__ + "static/media/hogwarts2.149f4998.png";